/**
 * Project Image Assets — Brand Photography (THE.K SEOUL)
 *
 * Usage:
 *   import { IMAGES } from '@/constants/images';
 *   <img src={IMAGES.productCutout} alt="..." />
 */

export const IMAGES = {
  /** 제품 컷아웃 */
  productCutout:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/53c7d1b0-c0d0-4942-8958-fe6f2c87eeed_compressed_product-cutout.webp',

  /** 부스 / 키오스크 */
  booth:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/88e24291-4e75-4fa8-bdd0-fb338c33e9d0_compressed_g-booth.webp',

  /** 브랜드 패널 */
  brandPanel:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/cb110832-83ec-48ba-a5b9-438a05d4c308_compressed_g-brand-panel.webp',

  /** 상담 장면 */
  consult:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/4d61e55d-3a5d-485c-9b31-e8f7ebc6e31b_compressed_g-consult.webp',

  /** 군중 / 사회적 증명 */
  crowd:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/2ead5877-ea53-4f19-914f-57c3d09163b3_compressed_g-crowd.webp',

  /** 모델 1 */
  model:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/a91a3ac2-41e8-45b5-b301-599cc362ac5c_compressed_g-model.webp',

  /** 모델 2 */
  model2:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/592bc016-ce62-4f0d-9688-c9a1c6b7b28e_compressed_g-model2.webp',

  /** 팀 사진 1 */
  team:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/a0e5b7e8-3f08-4b9a-9815-0f5041337752_compressed_g-team.webp',

  /** 팀 사진 2 */
  team2:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/efd5736b-115d-438c-8406-24da531a6773_compressed_g-team2.webp',

  /** 3-Step 라인업 투명배경 */
  threeStepSet:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/fdd440f4-784c-4da5-987e-9e32258180b3_RX.K-Seoul-Total-Solution3-Step_Transparent.jpg',

  /** 3-Step 세트 라이프스타일 사진 (대리석 배경) — 장바구니 썸네일 +
   *  /products 페이지의 3-Step Set 배너 이미지의 기본값(fallback)으로 공유됨 */
  threeStepSetLifestyle:
    'https://api.thekseoul.com/storage/v1/object/public/rxk-content/legacy/3dcb31c5-54bc-4823-bbbf-e9bc972ab657_Sample_Real-total.png',
} as const;